
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 10.333c1.042 0 1.927-.364 2.656-1.094.73-.729 1.094-1.614 1.094-2.656 0-1.041-.364-1.927-1.094-2.656-.729-.73-1.614-1.094-2.656-1.094-1.041 0-1.927.365-2.656 1.094-.73.73-1.094 1.615-1.094 2.656 0 1.042.365 1.927 1.094 2.656.73.73 1.615 1.094 2.656 1.094zm0-1.5a2.17 2.17 0 01-1.594-.656 2.17 2.17 0 01-.656-1.594c0-.625.219-1.156.656-1.594A2.17 2.17 0 0110 4.333a2.17 2.17 0 011.594.656c.437.438.656.97.656 1.594a2.17 2.17 0 01-.656 1.594A2.17 2.17 0 0110 8.833zm0 4c-2.028 0-3.875-.566-5.542-1.698C2.792 10.003 1.583 8.486.833 6.583c.75-1.903 1.959-3.42 3.625-4.552C6.125.9 7.973.333 10 .333s3.875.566 5.542 1.698c1.667 1.132 2.875 2.65 3.625 4.552-.75 1.903-1.959 3.42-3.625 4.552-1.667 1.132-3.514 1.698-5.542 1.698z"}})])
          )
        }
      }
    